export default __webpack_public_path__ + "static/media/8921.3aa2ff55.svg";